export default class UpdatePasswordModel {
  oldPassword?: string;

  newPassword?: string;

  checkPassword?: string;
}
